import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

interface SessionExpiredModalProps {
  /** Whether the modal is visible */
  open: boolean;
  /** Callback when user acknowledges and will be redirected to login */
  onConfirm: () => void;
}

/**
 * Modal dialog warning user that their session has expired.
 * Non-dismissable to ensure user acknowledges before continuing.
 */
export const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ open, onConfirm }) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth disableEscapeKeyDown>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningIcon color="error" />
          <span>Session Expired</span>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Your session has expired. Please save any unsaved work and sign in again.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Click "Sign In" to be redirected to the login page.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} variant="contained" color="primary" autoFocus>
          Sign In
        </Button>
      </DialogActions>
    </Dialog>
  );
};
